import { FileSource } from "./file.types";

export enum NotificationEventType {
  RESET_PASSWORD = "reset-password",
  USER_ACCOUNT_APPROVED = "user-account-approved",
  USER_ACCOUNT_RESET_PASSWORD = "user-account-reset-password",
  PAYMENT_FAILED = "payment-failed",
  RECEIVED_ADMIRATION = "received-admiration",
  CONTACT_JOINED = "contact-joined",
  USER_BLOCKED = "user-blocked",
  EVENT_USER_APPROVED = "event-user-approved",
  EVENT_USER_REMOVED = "event-user-removed",
  EVENT_DATE_UPDATED = "event-date-updated",
  EVENT_LOCATION_UPDATED = "event-location-updated",
  EVENT_DATE_AND_LOCATION_UPDATED = "event-date-and-location-updated",
  EVENT_CANCELLED = "event-cancelled",
  EVENT_PARTICIPANT_WITHDREW = "event-participant-withdrew",
  CHAT_NEW_MESSAGE = "chat-new-message",
  REFERRAL_REQUEST_CREATED = "referral-request-created",
}

export type Notification = {
  id: string;
  header: string;
  content: string;
  relativeUrl?: string;
  image?: FileSource;
  imagePreview?: FileSource;
  data: NotificationEvent["notification"]["additionalData"];
  isRead: boolean;
  createdAt: string;
};

export type NotificationEvent = {
  notification: {
    additionalData: {
      event: NotificationEventType;
      eventId?: string;
    };
    launchURL: string;
  };
};
